import React from 'react';
import 'styles/LoginPage.styl';
import {LoginBranding} from '@components/login/LoginBranding';

class PasswordPage extends React.Component {
  render() {
    return (
      <div className="login-page">
        <LoginBranding />
        <div className="sidebar">
          <div className="login-component-container">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

PasswordPage.displayName = 'PasswordPage';

export default PasswordPage;
